import * as ActionType from "../actionType";
import { fetchCareerPositionApi } from "../../services/page/careerpositions";

const getCareerPositionAction = () => {
  return async dispatch => {
    dispatchCareerPosition(dispatch);
  };
};

const dispatchCareerPosition = dispatch => {
  fetchCareerPositionApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_CAREER_POSITIONS,
      data
    });
  });
};

export { getCareerPositionAction, dispatchCareerPosition };



// WEBPACK FOOTER //
// ./src/actions/page/careerpositions.js